import { useState } from "react";
import { toast } from "sonner";
import api, { fmtErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import PasswordInput from "@/components/PasswordInput";

/* Shared "Password & security" panel for member dashboards. Google-only
   accounts (no password) see a note instead of the form. */
export default function ChangePassword() {
  const { user } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) { toast.error("New passwords don't match."); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated — use it next time you sign in.");
      setCurrent(""); setNext(""); setConfirm("");
    } catch (err) {
      toast.error(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="mt-16 panel p-8 max-w-xl" data-testid="change-password">
      <p className="overline-label mb-6">Password & security</p>
      {user?.has_password === false ? (
        <p className="text-sm text-muted-foreground" data-testid="change-password-google-note">
          Your account signs in with Google — there's no password to change.
        </p>
      ) : (
        <form onSubmit={submit}>
          <PasswordInput data-testid="change-current-password" required value={current}
            onChange={(e) => setCurrent(e.target.value)} placeholder="Current password" className="field mb-4" autoComplete="current-password" />
          <PasswordInput data-testid="change-new-password" required minLength={8} value={next}
            onChange={(e) => setNext(e.target.value)} placeholder="New password (8+ characters)" className="field mb-4" autoComplete="new-password" />
          <PasswordInput data-testid="change-confirm-password" required minLength={8} value={confirm}
            onChange={(e) => setConfirm(e.target.value)} placeholder="Repeat the new password" className="field mb-6" autoComplete="new-password" />
          <button data-testid="change-password-submit" disabled={busy} className="btn-outline !px-6 !py-3 disabled:opacity-40">
            {busy ? "Updating…" : "Change password"}
          </button>
        </form>
      )}
    </section>
  );
}
